import initCtaTracking from '@utils/trackingCta';
import initImageAndVideoAnalytics from '@utils/trackingMedia';
import initDashboardAnalytics from '@utils/trackingDashboard';
import cAppeared from './components/c-appeared';
import cOutline from './components/c-outline';
import preloader from './components/c-preloader';
import header from './components/c-header';
import select from './components/c-select';
import responsiveImages from './components/c-responsive-images';
import fullheightFix from './utils/fullheightFix';
import MediaControl from './components/c-media-control';
import BookingWidget from './components/c-booking-widget';
import initNavigationTracking from './components/c-navigation';
import formDateDisplay from './components/c-form-date-display';

cAppeared();
cOutline();
preloader();
header();
select();
responsiveImages();
fullheightFix();
MediaControl.init();
BookingWidget.init();

const initSiteAnalytics = () => {
  initCtaTracking();
  initImageAndVideoAnalytics();
  initDashboardAnalytics();
};

initSiteAnalytics();
initNavigationTracking();
formDateDisplay.init();

document.addEventListener('wpcf7domupdated', (event) => {
  if (!event || !event.target) {
    return;
  }

  formDateDisplay.init(event.target);
});
